import { NavigateFunction } from 'react-router'

import { api } from 'app/services'
import { report } from 'utils'

export const fetchConnectionAllowed = (
  quoteId: string,
  setTooManyConnections: (arg: boolean) => void,
  navigate: NavigateFunction,
): void => {
  api
    .get(`/quoting/quotes/${quoteId}/open-banking-connection-allowed`)
    .then(({ data }) => {
      setTooManyConnections(!data.connectionAllowed)
    })
    .catch((error) => {
      if (error && error.response && error.response.status < 500) {
        setTooManyConnections(false)
      } else {
        report(error, 'Error connecting to open banking')
        navigate(`/quote/${quoteId}/error`, { state: { from: location.pathname } })
      }
    })
}
